import React, { useState } from 'react';
import xImage from '../../assets/images/dp-login/x.png';
import subTitle from '../../assets/images/dp-login/21.png';
import logo from '../../assets/images/dp-login/new-logo.png';
import title from '../../assets/images/dp-login/title.png';
import sp from '../../assets/images/dp-login/sp.png';
import bg from '../../assets/images/dp-login/bg.png';
import SocialLoginButtons from '../../components/socialLogin/SocialLoginButtons';
import { useTranslation } from 'react-i18next';
import GuestInquiryModal from '../../components/modals/GuestInquiryModal';

export default function SleepingJellyLoginPage() {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <GuestInquiryModal isOpen={isOpen} setIsOpen={setIsOpen} />
      <div className="w-full h-full bg-black flex-col flex">
        <div
          className="flex items-center flex-col"
          style={{
            backgroundImage: `url(${bg})`,
            backgroundSize: 'cover',
            backgroundPosition: 'left top',
            backgroundRepeat: 'no-repeat',
            height: '68%',
            paddingBottom: 50,
          }}
        >
          <div className="flex flex-col justify-center items-center mt-10 gap-2">
            <img src={logo} alt="jelly-logo" className="w-[75px]" />
            <img src={xImage} alt="x-img" className="w-[24px]" />
            <img src={sp} alt="sp-logo" className="w-[41px]" />
          </div>
          <div className="flex flex-col justify-center items-center flex-1">
            <img src={title} alt="title" className="w-72" />
            <img src={subTitle} alt="sub-title" className="w-52 mt-3" />
          </div>
        </div>
        <div
          className="flex flex-1 items-center justify-center h-full relative"
          style={{ backgroundColor: '#13171E', paddingBottom: 50 }}
        >
          <div
            style={{
              position: 'absolute',
              height: 50,
              width: '100%',
              top: -50,
              backgroundColor: '#13171E',
              borderTopLeftRadius: '50px',
              borderTopRightRadius: '50px',
            }}
          ></div>
          <div className="flex justify-center items-center h-full flex-col gap-[16px]">
            <span className="text-[15px] text-N1 font-medium mb-4">{t('sleepingJelly.socialLogin')}</span>
            <div className="flex w-full h-[48px] justify-center items-center gap-[12px] ">
              <SocialLoginButtons />
            </div>
            <button
              onClick={() => {
                setIsOpen(true);
              }}
              className="text-[15px] text-N1 font-medium mt-4"
            >
              {t('sleepingJelly.problem')}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
